import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode = "light" | "dark" | "system";
export type EffectiveThemeMode = "light" | "dark";

interface ThemeStore {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  getEffectiveMode: () => EffectiveThemeMode;
}

// Función para obtener la preferencia del sistema
const getSystemPreference = (): EffectiveThemeMode => {
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
};

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set, get) => ({
      mode: "system",
      setMode: (mode) => set({ mode }),
      getEffectiveMode: () => {
        const { mode } = get();
        if (mode === "system") {
          return getSystemPreference();
        }
        return mode;
      },
    }),
    {
      name: "theme-storage",
    }
  )
);
